










































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RiwayatPrmrj from "@/components/pemeriksaan/assesmen/prmrj/RiwayatPrmrj.vue";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import { userModule } from "@/store/modules/user";
import { storePrmrj } from "@/store/modules/prmrj";
import { appModule } from "@/store/modules/app";
import DataPrmrj from "@/services/DataPrmrj";
import { storeSoap } from "@/store/modules/soap";

@Component({
  components: {
    DokterAutoComplete,
    RiwayatPrmrj,
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPrmrj extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  tglShow = false;
  time = new Date()
    .toLocaleString("en-CA", { hour12: false, timeZone: "Asia/Jakarta" })
    .toString()
    .substr(12, 8);
  maxDate = new Date().toISOString().substr(0, 10);
  today = new Date().toISOString().substr(0, 10);
  waktu = this.today + " " + this.time;
  dokter = {};
  prmrj = {
    tgl_periksa: this.today,
    // tgl_periksa: this.today + " " + this.time,
    dpjp: {
      id: this.sessLogin.id,
      nama: this.sessLogin.nama,
    },
    uraian_klinis: "",
    diagnosa: "",
    tindakan: "",
  };
  saving = false;
  validasi = [(v) => !!v || "*Kolom ini harus diisi"];

  mounted() {
    this.waktu = this.today + " " + this.time;
  }

  setTime(val) {
    // this.time = val;
    this.prmrj["tgl_periksa"] = val;
  }
  get sessLogin() {
    return userModule.user;
  }

  get stateRiwayatPrmrj() {
    return storePrmrj.riwayatPrmrj;
  }
  get statePrmrj() {
    return storePrmrj.detailPrmrj;
  }

  get statesoap() {
    return storeSoap.detailSoap[0];
  }

  setDokter(val) {
    this.prmrj["dpjp"] = val;
  }

  @Watch("statePrmrj")
  valprmrj(val) {
    console.log("va", val);
    if (val == null) {
      console.log("kosong", val);
      this.prmrj = {
        tgl_periksa: this.today,
        // tgl_periksa: this.today + " " + this.time,
        dpjp: {
          id: this.sessLogin.id,
          nama: this.sessLogin.nama,
        },
        uraian_klinis: "",
        diagnosa: "",
        tindakan: "",
      };
    } else {
      console.log("isi");
      let waktu;
      if (val["tgl_periksa"]) {
        waktu = val["tgl_periksa"];
      } else {
        waktu = this.today + " " + this.time;
      }
      this.prmrj = {
        tgl_periksa: waktu,
        dpjp: val["dpjp"],
        uraian_klinis: val["uraian_klinis"],
        diagnosa: val["diagnosa"],
        tindakan: val["tindakan"],
      };
    }
  }

  simpan() {
    const param = {
      unit_id: this.sessLogin.unit_id,
      reg: this.register,
      id: this.sessLogin.id,
    };
    console.log(this.prmrj);
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      if (!this.saving) {
        this.saving = true;
        if (this.statePrmrj == undefined) {
          const dt = DataPrmrj.saveDataPrmrj(
            this.register,
            this.rm,
            this.prmrj
          );
          dt.then((dt) => {
            this.saving = false;
            if (dt["status"] != 1) {
              // appModule.sendErrorAlert(dt["err"]);
            } else {
              storePrmrj.actPrmrjByReg(param);
              storePrmrj.actPrmrjByRM(this.rm);
              appModule.NoticeDelay("Berhasil Simpan PRMRJ");
            }
          });
        } else {
          const dt = DataPrmrj.editDataPrmrj(
            this.statePrmrj["id"],
            this.register,
            this.rm,
            this.prmrj
          );
          dt.then((dt) => {
            this.saving = false;
            if (dt["status"] != 1) {
              // appModule.sendErrorAlert(dt["err"]);
            } else {
              storePrmrj.actPrmrjByReg(param);
              storePrmrj.actPrmrjByRM(this.rm);
              appModule.NoticeDelay("Berhasil Ubah PRMRJ");
            }
          });
        }
      }
    }
  }

  generate() {
    if (
      this.prmrj.uraian_klinis ||
      this.prmrj.diagnosa ||
      this.prmrj.tindakan
    ) {
      appModule.sendErrorAlert(
        "Tidak bisa Generate karena sudah ada isian yg anda buat"
      );
    } else {
      this.prmrj.uraian_klinis = this.statesoap["s"];
      this.prmrj.diagnosa = this.statesoap["a"];
      this.prmrj.tindakan = this.statesoap["p"];
    }
  }
}
